import type { Logger } from '@interopio/gateway/logging/api';

export function isClientDisconnectedError(error: Error): boolean {
    if (error === null || error === undefined) {
        return false;
    }
    const { code, message } = error as any;
    return code === 'ECONNRESET' ||
        code === 'EPIPE' ||
        code === 'ERR_STREAM_PREMATURE_CLOSE' ||
        message?.toLowerCase().includes('client aborted') ||
        message?.toLowerCase().includes('socket hang up') ||
        message?.toLowerCase().includes('aborted');
}

export function checkAndLogClientDisconnectedError(error: Error, logger: Logger): boolean {
    const isClientDisconnected = isClientDisconnectedError(error);
    if (isClientDisconnected) {
        if (logger.enabledFor('trace')) {
            logger.debug('looks like the client has gone away:', error);
        }
        else if (logger.enabledFor('debug')) {
            logger.debug(`looks like the client has gone away: ${error.message} (For full stack trace enable trace logging level.)`);
        }
        return true;
    }
    return false;
}
